module.exports = __webpack_public_path__ + "media/images/next-icon-90fff5e5.svg";